import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-video-editing',
  templateUrl: './video-editing.component.html',
  styleUrls: ['./video-editing.component.css']
})
export class VideoEditingComponent implements OnInit {

  constructor(private titleService: Title, private metaService: Meta) {}

  ngOnInit(): void {
    // Set the page title
    this.titleService.setTitle('Expert Video Editing Services | Transform Your Videos with Ease');

    // Add meta tags
    this.metaService.addTags([
      { name: 'description', content: 'Our expert video editing services make it easy to transform your raw footage into stunning videos. Experience precision, creativity, and unmatched quality with us.' },
      { name: 'keywords', content: 'Professional Video Editing Services' }
    ]);
  }
}
